var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 145C118.137 145 145 118.137 145 85C145 51.8629 118.137 25 85 25C51.8629 25 25 51.8629 25 85C25 118.137 51.8629 145 85 145Z",
    fill: "#8BF2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1 88C107.6 87.7 107.3 87.3 107.2 86.8L105.8 82L108.8 81.1C109.3 80.9 109.7 80.6 109.8 80.4L108.6 76.2C108.3 76 107.8 76 107.4 76.1L104.4 77L103.2 72.7C102.9 71.5 103.5 69.8 104.9 69.4L107.9 68.5L107.6 67.3C107.4 66.7 107.5 66 107.7 65.5C108 64.9 108.5 64.4 109.2 64.2L114 62.8C115.3 62.4 116.7 63.3 117.1 64.6L117.4 65.8L120.9 64.8C121.6 64.6 122.5 64.7 123.3 65.1C123.9 65.4 124.4 65.9 124.5 66.5L125.7 70.8L121.8 72C121.7 72 121.7 72 121.7 72.1C121.7 72.1 121.7 72.2 121.8 72.5L123 76.7C123 76.9 123.1 77 123.1 77H123.2L127.1 75.9L128.5 80.7C128.6 81.2 128.6 81.6 128.3 82.1C127.8 83 126.6 83.4 126.2 83.6L122.7 84.6L123.2 86.3C123.4 86.9 123.3 87.6 123 88.1C122.7 88.7 122.1 89.1 121.5 89.3L116.7 90.7C116 90.9 115.4 90.8 114.8 90.5C114.2 90.2 113.8 89.7 113.6 89L113.1 87.3L110.1 88.2C109.4 88.4 108.7 88.3 108.1 88ZM108.2 83.3L109.1 86.3C109.1 86.3 109.4 86.4 109.8 86.2L114.6 84.8L115.6 88.4C115.7 88.7 115.9 88.9 116.3 88.8L121.1 87.4C121.3 87.4 121.4 87.3 121.5 87.1C121.6 87 121.6 86.8 121.5 86.7L120.5 83.1L125.8 81.6C126.4 81.4 126.7 81.1 126.8 81L125.9 78.1L123.8 78.7C123.2 78.9 122.6 78.8 122.2 78.6C121.6 78.3 121.3 77.6 121.2 77.1L119.9 73C119.3 71 120.5 70.4 121.2 70.2L123.3 69.6L122.6 67.2C122.6 67.2 122.5 67.1 122.3 66.9C122 66.7 121.6 66.7 121.4 66.7L116.1 68.2L115.2 65.2C115.1 64.9 114.8 64.7 114.5 64.8L109.7 66.2C109.5 66.2 109.4 66.3 109.4 66.5C109.3 66.6 109.3 66.8 109.4 67L110.3 70L105.5 71.4C105.1 71.5 105 72 105.1 72.3L105.8 74.7L107 74.4C107.9 74.2 108.9 74.2 109.6 74.6C110.1 74.9 110.4 75.3 110.6 75.8L111.8 80C112 80.7 111.8 81.4 111.2 82.1C110.8 82.5 110.2 82.9 109.6 83.1L108.2 83.3Z",
    fill: "#4B27E0",
    stroke: "#4B27E0",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.3 76.8999L98.6 77.6999L97.3 73.1999C97 72.2999 96.4 71.0999 95.6 71.2999L91.5 72.4999L92.4 75.7999C92.7 76.6999 92.4 76.7999 91.6 76.9999L87.4 78.1999C86.6 78.3999 86 78.5999 85.7 77.6999L84.8 74.3999L81.5 75.2999C80.7 75.4999 80.5 76.9999 80.7 77.8999L82 82.3999L79.6 83.0999C78.8 83.2999 78 84.0999 78.2 84.9999L79.6 89.7999C79.9 90.6999 81.1 91.0999 81.8 90.8999L84.2 90.1999L85.3 93.9999C85.6 94.8999 86.3 95.1999 87.1 94.9999L90.4 94.0999L89.8 92.1999C89.5 91.2999 89.8 89.7999 90.6 89.5999L94.8 88.3999C95.6 88.1999 96.2 89.3999 96.5 90.2999L97.1 92.1999L101.2 90.9999C102 90.7999 102.1 90.1999 101.8 89.2999L100.7 85.4999L103.4 84.6999C104.2 84.4999 104.6 83.5999 104.4 82.6999L103 77.8999C102.9 76.8999 102.1 76.6999 101.3 76.8999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.7 54H65.7002V106H142.7V54Z",
    stroke: "#4B27E0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2002 48.5H60.2002V58.5H70.2002V48.5Z",
    fill: "#4B27E0",
    stroke: "#4B27E0",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.2 48.5H137.2V58.5H147.2V48.5Z",
    fill: "#4B27E0",
    stroke: "#4B27E0",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.2 101.5H137.2V111.5H147.2V101.5Z",
    fill: "#4B27E0",
    stroke: "#4B27E0",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2002 101.5H62.2002V111.5H72.2002V101.5Z",
    fill: "#4B27E0",
    stroke: "#4B27E0",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5004 139.1L53.7004 127.3L65.5004 136.4L73.0004 95L36.9004 114.7L48.1004 123.1L38.9004 134.9L44.5004 139.1Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8002 142.5L55.9002 130.6L67.8002 139.8L75.2002 98.3999L39.2002 118.1L50.4002 126.4L41.2002 138.3L46.8002 142.5Z",
    fill: "#17E5A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2002 42.5H41.2002V95.5H51.2002V42.5Z",
    stroke: "#4B27E0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2002 87.3H51.2002",
    stroke: "#4B27E0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2002 42.5L46.2002 29.5L51.2002 42.5",
    stroke: "#4B27E0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7002 36H48.7002",
    stroke: "#4B27E0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.3992abfd.svg";
export { ForwardRef as ReactComponent };